// extracted by mini-css-extract-plugin
export default {"divStyle":"Profile_divStyle__MqIm+","imgStyle":"Profile_imgStyle__6Q6Jk"};